<template>
    <section v-if="products" class="items">
        <router-link v-for="p in products"
                     :key="p.slug"
                     @click.native="scrollToTop"
                         :to="{name: 'editor', params:{slug: p.slug}}"
            >
                <img v-if="p.menu_image" :src="p.menu_image.medium">
                <h3>{{ p.modelo }}</h3>
            </router-link>
    </section>

</template>

<script>
    export default {
        props: {
            products: Array
        },
        methods: {
            scrollToTop() {
                console.log("to top");
                window.scrollTo(0,0);
            }
        },

    }
</script>
